import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { useSales } from "@/lib/sales";
import { AlertTriangle } from "lucide-react";

// WHAT'S MISSING says it too when a night's Recommended to sell list wasn't worked out (his plan, S2.2: never silent).
export function SalesNightNote() {
  const sales = useSales();
  const [night, setNight] = useState(null);
  useEffect(() => {
    if (sales.any) api.get("/sales/recommended/night").then((r) => setNight(r.data)).catch(() => setNight(null));
  }, [sales.any]);
  if (!sales.any || !night?.missed) return null;
  return (
    <Link to="/sales" data-testid="whats-missing-sales-night" className="flex items-center gap-2 rounded-lg border border-amber-300 bg-amber-50 px-3 py-2 text-sm text-amber-950 hover:bg-amber-100 mb-3">
      <AlertTriangle className="w-4 h-4 shrink-0" />
      <span><b>Recommended to sell wasn't worked out as planned.</b> {night.missed}</span>
    </Link>
  );
}
